import classNames from 'classnames';
import React, { ChangeEvent, FocusEvent, KeyboardEvent, MouseEvent } from 'react';
import { KeyCode } from '../../types';
import './Checkbox.scss';
import ICheckboxProps from './CheckboxProps';

const Checkbox = ({
  onChange,
  onClick,
  onFocus,
  onBlur,
  onKeyDown,
  checked,
  value,
  disabled,
  type,
  className,
  label,
}: ICheckboxProps) => {
  const classes = classNames(
    {
      checkbox: true,
      disabled: disabled,
      [`checkbox-${type}`]: true,
    },
    className
  );

  function handleChange(event: ChangeEvent<HTMLInputElement>) {
    if (!disabled) {
      onChange(event.target.checked, value);
    }
  }

  function handleClick(event: MouseEvent) {
    event.stopPropagation();
    event.nativeEvent.stopPropagation();

    if (!disabled && onClick) {
      onClick(event);
    }
  }

  function handleFocus(event: FocusEvent) {
    if (!disabled && onFocus) {
      onFocus(event);
    }
  }

  function handleBlur(event: FocusEvent) {
    if (!disabled && onBlur) {
      onBlur(event);
    }
  }

  function handleKeyDown(event: KeyboardEvent) {
    if (!disabled) {
      onKeyDown?.(event);
      if (event.keyCode === KeyCode.ENTER) {
        event.stopPropagation();
        onChange(!checked, value);
      }
    }
  }

  return (
    <label className={classes}>
      <input
        type="checkbox"
        value={value}
        checked={checked}
        onFocus={handleFocus}
        onBlur={handleBlur}
        onChange={handleChange}
        onClick={(e) => e.stopPropagation()}
        onKeyDown={handleKeyDown}
      />
      <span className="checkmark" onClick={handleClick} />
      {label && <div className="checkbox-label">{label}</div>}
    </label>
  );
};

Checkbox.defaultProps = {
  type: 'basic',
};

export default Checkbox;
